module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='info-btn' v-bind:data-input-field='fieldName' data-toggle='tooltip' data-original-title=''>\n  <i class='fa fa-icon fa-question'></i>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
